export default __webpack_public_path__ + "static/media/img1.65b2f21a.jpg";